import { useContext} from "react";
import BreakPoints from "../../BreakPoints";
import AskState from "./helper/AskState";
import { QuestionsPageContext } from "../../context/QuestionsPageContext";
import Tags from "./helper/Tags";
import AskBox from "./helper/AskBox";

export default function QAside() {
  const { medium, large, xLarge, xXLarge } = BreakPoints();
  const { asideRef, order, setPeriod, setOrder } = useContext(QuestionsPageContext);
  const answersCount = "answers_count";
  
  return (
    <aside ref={asideRef}>
      {(xLarge || xXLarge) && <AskState />}
      <ul className="filter-q ">
        <li
          data-sort="desc"
          className={!order ? "sort-by" : ""}
          onClick={() => {
            setOrder(null);
            setPeriod("");
          }}>
          new
        </li>
        {(medium || large) && (
          <li>
            <AskState pos={"aside"} />
          </li>
        )}

        <li
          onClick={() => {
            setOrder(answersCount);
            setPeriod("today");
          }}
          className={order === answersCount ? "sort-by" : ""}>
          hot topics
        </li>
      </ul>
      <Tags />

      <AskBox />
    </aside>
  );
}
